// src/config/shipmentGroupConfig.js

export const ImportStatusAuditGroup = {
    BookingStage: {
        label: "📦 Booking & Documentation",
        keys: [
            "BkgConfirmationSentToCust",
            "ShippingInstructionssenttoAgent",
            "CarrierBookingConfirmation",
        ],
    },

    HBLProcessing: {
        label: "📄 HBL / Draft Processing",
        keys: [
            "DraftHBLIssued",
            "DraftHBLConfirmation",
        ],
    },

    FilingStage: {
        label: "🛃 ISF & AMS Filing",
        keys: [
            "ISFDetailsReceived",
            "ISFFilingSent",
            "AMSHBLFilingCompleted",
            "AMSHBLREVISED",
        ],
    },

    ShipmentStage: {
        label: "🚢 Shipment Execution",
        keys: [
            "TelexorOriginalHBLReceived",
            "MBLTelexRelease",
            "Telex",
            "ContainerOnboard",
        ],
    },

    DocumentationStage: {
        label: "📥 Document Handling",
        keys: [
            "CommercialDocumentsReceived",
            "CarrierMblReceived",
        ],
    },

    ArrivalStage: {
        label: "📬 Arrival & Notification",
        keys: [
            "ArrivalNoticeReceivedfromCarrier",
            "ArrivalNoticeSenttoCHB",
            "ArrivalNoticeConfirmedfromCustomer",
            "ConfirmArrival",
        ],
    },

    ClearanceStage: {
        label: "🧾 Charges & Clearance",
        keys: [
            "DestinationChargesPaidtoCarrier",
            "ContainersAvailable",
            "CustomsHoldExam",
            "CustomsBrokerageRequired",
            "CustomsRelease",
            "CarrierRelease",
        ],
    },

    InvoiceStage: {
        label: "💰 Invoice & Billing",
        keys: [
            "CommercialInvoiceReceived",
            "ReadyToInvoice",
            "InvoiceCreated",
            "InvoiceSentToCustomer",
        ],
    },

    DeliveryStage: {
        label: "🚚 Delivery Process",
        keys: [
            "DeliveryOrderSent",
            "DeliveryOrderConfirmed",
            "ReleaseOrderSent",
            "ReleaseOrderConfirmed",
            "DeliveryDate",
        ],
    },

    ContainerMovement: {
        label: "🔄 Container Movement",
        keys: [
            "EmptyContainerReturn",
            "FirstContainerPickedUp",
            "LastContainerPickedUp",
        ],
    },

    ClosureStage: {
        label: "✅ Closure",
        keys: [
            "FileClosed",
        ],
    },
};